import { createContext } from 'react';

import { captureException } from '@sentry/react';
import { useQueryClient } from '@tanstack/react-query';

import type { InFieldUser, InFieldUserPreferences } from '@cognite/apm-client';
import { makeToast } from '@cognite/cogs-lab-v11';

import { useCurrentUserContext } from '../../../../providers/current-user-provider/current-user-provider';
import { useUserServices } from '../cdm-use-user-services';

export type UserPreferencesServiceDependencies = {
  upsert: (
    preferences: InFieldUserPreferences[]
  ) => Promise<{ data: { items: InFieldUserPreferences[] } }>;
};

export interface UseUpsertCurrentUserPreferencesContextInterface {
  useCurrentUserContext: () => {
    user: InFieldUser;
  };
  useUserServices: () => {
    userPreferencesService: UserPreferencesServiceDependencies;
  };
  useQueryClient: typeof useQueryClient;
  makeToast: typeof makeToast;
  captureException: typeof captureException;
}

export const defaultValue: UseUpsertCurrentUserPreferencesContextInterface = {
  useCurrentUserContext,
  useUserServices,
  useQueryClient,
  makeToast,
  captureException,
};

export const UseUpsertCurrentUserPreferencesContext =
  createContext<UseUpsertCurrentUserPreferencesContextInterface>(defaultValue);
